import wx from 'weixin-js-sdk'			//微信sdk依赖
// import axios from 'axios';    // 引用全局
import qs from 'qs'
import { md5 } from "@/utils/md5.js";
import request from "@/utils/request"
import { keysort, getstring, config } from "@/utils/common.js";

//要用到微信API
function getJSSDK(dataForWeixin) {
    // 调用后台接口换取参数
    var ondata = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
    }
    const sign = md5(getstring(keysort(ondata)))
    ondata = {
        ...ondata,
        sign
    }
    request({
        url: "https://www.yaoking.cn/openapi/emc_member/share",// 需要改成自己对应的接口
        method: 'POST',
        data: qs.stringify(ondata)
    }).then(res => {
        console.log(res, "666")
        wx.config({
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: "wxfa09add29437e468", // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            // jsApiList: jsApiList // 必填，需要使用的JS接口列表
            jsApiList: [ //需要调用的JS接口列表
                'onMenuShareAppMessage', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
                'onMenuShareTimeline', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
                // 'getLocation'  //获取定位
            ]
        })
        // wx.checkJsApi({
        //     jsApiList: [
        //         'onMenuShareAppMessage', 'onMenuShareTimeline'
        //     ]
        // })
        console.log("7777")
        wx.ready(function () {
            console.log("888")    //需在用户可能点击分享按钮前就先调用
            wx.onMenuShareAppMessage({
                title: dataForWeixin.title,
                desc: dataForWeixin.desc,
                link: dataForWeixin.linkurl,
                imgUrl: dataForWeixin.img,
                trigger: function trigger() { },
                success: function success(result) {
                    console.log(result);
                },
                cancel: function cancel(result) {
                    console.log(result);
                },
                fail: function fail(result) {
                    alert(JSON.stringify(result));
                }
            });
            console.log(dataForWeixin, "777")
            wx.onMenuShareTimeline({
                title: dataForWeixin.title,
                desc: dataForWeixin.desc,
                link: dataForWeixin.linkurl,
                imgUrl: dataForWeixin.img,
                trigger: function trigger() { },
                success: function success(result) {
                    console.log(result);
                },
                cancel: function cancel() {
                    console.log('已取消');
                },
                fail: function fail(result) {
                    alert(JSON.stringify(result));
                }
            });
        });
        wx.error(function (result) {
            alert(JSON.stringify(result) + "微信验证失败");
        });
    })
}


export default {
    // 获取JSSDK
    getJSSDK: getJSSDK
}